import React, { Component } from 'react';
import Footer from './footer';
import Header from './header';
import TrainingPic from './data/TrainingPic.jpg';
import TrainingPic1 from './data/training_pic_1.jpg';
import TrainingPic2 from './data/training_pic_2.jpg';
import GalleryHeader from './data/gallery/2025_banner_1st _page.png';
import GalleryHeader2 from './data/gallery2/Corporate Risk Awareness.png';
import { Link } from "react-router-dom";
class Training extends Component {
    state = {  } 
    constructor(props) {
        super(props);
        window.scrollTo(0, 0);
    }
    render() { 
        return (
            <div className='d-flex flex-column min-vh-100 '>
                <Header onlanguage={this.props.onlanguage}
                    onChangeLanguage={this.props.onChangeLanguage}
                    onEngLanguage={this.props.onEngLanguage}
                    onGeoLanguage={this.props.onGeoLanguage}
                />
                {/*
                <img src={Picture3} alt="Picture3" className='w-100'/>*/}
                <div className='pb-2 flex-grow-1'>
                    {/*
                    <div className='h2 px-5 mt-4'>
                        Training programs
                    </div>
                    <div className='px-5 mt-4'>
                    We provide Training and awareness programs to financial institutions, covering non-financial risk
                    management programs, focusing on 1st and 2nd line business roles.
                    </div>
                    <div className='px-5 mt-4'>
                        <ul className='row' style={{listStyle: 'square'}}>
                            <li className='col-12 m-2 col-sm-6'>Programs are developed and delivered based on International best practices and meet
                            regulatory expectations.</li>
                            <li className='col-12 m-2 col-sm-5'>We practice online and in-person training sessions</li>
                            <li className='col-12 m-2 col-sm-6'>We offer Interactive, Engaging and Motivating sessions for participants</li>
                            
                            
                        </ul>
                    </div>*/}
                    <div className='row w-100 p-0 m-0'>
                            <div className='col-12 col-md-6 col-lg-4 m-0 py-4 px-3 px-sm-4 px-xxl-3 d-block d-md-none d-lg-block'>
                                <div className='px-xxl-5 py-2'>
                                    <img src={TrainingPic} alt="training_pic" style={{maxWidth: '100%'}}/>
                                </div>
                            </div>

                            <div className='col-12 col-md-6 col-lg-4 py-2 px-3 px-sm-4 px-md-4 px-lg-2 px-xl-3' style={{backgroundColor: '#F0F0F0', lineHeight: '2'}}>
                                <div className='pb-2 pt-sm-4'>
                                    <div className='custom-font-size-heading'>
                                        <b>
                                            <div className={this.props.onEngLanguage()}>Training programs</div>
                                        </b>
                                    </div>
                                    <div className='custom-font-size-heading-geo'>
                                        <b>    
                                            <div className={this.props.onGeoLanguage()}>შემოგვიერთდი და იზრუნე შენს განვითარებაზე!</div>
                                        </b>
                                    </div>
                                </div>
                                <div className='mt-2' style={{ textAlign: 'justify', textJustify: 'inter-word'}}>
                                    <div className='custom-font-size-text-2'>
                                        <div className={this.props.onEngLanguage()}>
                                            <div>
                                                We provide training and awareness programs covering various risk management frameworks. 
                                                <br />
                                                Training programs are developed and delivered based on best practices.                                    
                                            </div>
                                            <ul style={{listStyle: 'square'}}>
                                                <li>
                                                    We offer Interactive, Engaging, and Motivating sessions for participants
                                                </li>
                                                <li> 
                                                    We practice online and in-person training sessions
                                                </li>
                                            </ul>
                                
                                            <div>
                                                Get ready to level up! Our training calendar is coming soon! 🎉 
                                                <br />
                                                Follow us on <a href="https://www.linkedin.com/company/riskadvisor-ge/">LinkedIn</a> to be the first to know!
                                            </div>
                                        </div>
                                    </div>
                                    <div className='custom-font-size-text-geo'>
                                        <div className={this.props.onGeoLanguage()}>
                                            <div>
                                                ჩვენ გთავაზობთ რისკის მართვის <b>ტრენინგ-პროგრამებს</b>, რომელიც შემუშავებულია 
                                                საუკეთესო პრაქტიკებისა და საერთაშორისო სტანდარტების საფუძველზე.  
                                            </div>
                                            <div>
                                                ჩვენი ტრენინგ-პროგრამა მიზნად ისახავს მონაწილის <b>პროფესიული უნარების</b> განვითარებას და ეხმარება მას გაიღრმავოს ცოდნა
                                                რისკის მართვის თანამედროვე მიდგომებთან მიმართებაში. 
                                                ჩვენ გულდასმით ვეცნობით მონაწილეთა დაგროვილ გამოცდილებას და ვთავაზობთ მათ საჭიროებებზე მორგებულ ტრენინგებს. 
                                                                                    
                                            </div>
                                            <div>
                                                ჩვენ გპირდებით <b>ინტერაქტიულ</b> და <b>საინტერესო სესიებს</b>, რეალური ბიზნეს-ქეისების განხილვითა და პრაქტიკული გამოცდილების გაზიარებით. 
                                                    
                                            </div>
                                            <div>
                                            <b> მზად ხარ საინტერესო გამოცდილებისათვის?</b> 
                                            </div>
                                            <div>
                                                თვალი გვადევნეთ <a href="https://www.linkedin.com/company/riskadvisor-ge/">LinkedIn</a>  და არ გამოტოვოთ თქვენთვის საინტერესო კურსი.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            <div className='col-12 col-md-6 col-lg-4 py-2 px-3 px-sm-4' style={{backgroundColor: '#F0F0F0', lineHeight: '2'}}>
                                <div className='d-none d-md-block d-lg-none'>
                                    <div className='py-4'>
                                        <img src={TrainingPic} alt="training_pic" style={{maxWidth: '100%'}}/>
                                    </div>
                                </div>
                                <div className='d-block position-relative py-4' >
                                    <Link to="/training/operational_risk">
                                        <img src={TrainingPic1} alt="Training_pic_1" className='rounded' style={{maxWidth: '100%'}}/>
                                        <div className='position-absolute bottom-0 start-50 translate-middle-x' style={{color: '#003968',width: '100%', textAlign: 'center'}} >
                                            {/*<div className='h5 mb-3 py-1 Istock' style={{backgroundColor: 'white', borderStyle: 'solid', borderColor: '#003968', borderWidth: '1px'}}>
                                                Section 1
                                            </div>*/}
                                        </div>
                                    </Link>
                                </div>
                                <div className='d-block position-relative py-4' >
                                    <Link to="/gallery/ORMMasterclass2025Gallery">
                                        <img src={GalleryHeader} alt="Training_pic_3" className='rounded' style={{maxWidth: '100%'}}/>
                                        <div className='position-absolute bottom-0 start-50 translate-middle-x' style={{color: '#003968',width: '100%', textAlign: 'center'}} >
                                            {/*<div className='h5 mb-3 py-1 Istock' style={{backgroundColor: 'white', borderStyle: 'solid', borderColor: '#003968', borderWidth: '1px'}}>
                                                Section 2
                                            </div>*/}
                                        </div>
                                    </Link>
                                </div>
                                 <div className='d-block position-relative py-4' >
                                    <Link to="/gallery/CRAGallery">
                                        <img src={GalleryHeader2} alt="Training_pic_4" className='rounded' style={{maxWidth: '100%'}}/>
                                        <div className='position-absolute bottom-0 start-50 translate-middle-x' style={{color: '#003968',width: '100%', textAlign: 'center'}} >
                                            {/*<div className='h5 mb-3 py-1 Istock' style={{backgroundColor: 'white', borderStyle: 'solid', borderColor: '#003968', borderWidth: '1px'}}>
                                                Section 2
                                            </div>*/}
                                        </div>
                                    </Link>
                                </div>
                                <div className='d-block position-relative py-4' >
                                    <Link to="/training/risk_management_for_microfinance">
                                        <img src={TrainingPic2} alt="Training_pic_2" className='rounded' style={{maxWidth: '100%'}}/>
                                        <div className='position-absolute bottom-0 start-50 translate-middle-x' style={{color: '#003968',width: '100%', textAlign: 'center'}} >
                                            {/*<div className='h5 mb-3 py-1 Istock' style={{backgroundColor: 'white', borderStyle: 'solid', borderColor: '#003968', borderWidth: '1px'}}>
                                                Section 2
                                            </div>*/}
                                        </div>
                                    </Link>
                                </div>
                            </div>

                        </div>
                </div>

                <Footer
                    onlanguage={this.props.onlanguage}
                    onChangeLanguage={this.props.onChangeLanguage}
                    onEngLanguage={this.props.onEngLanguage}
                    onGeoLanguage={this.props.onGeoLanguage}
                />
            </div>
        );
    }
}
 
export default Training;
